import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { api } from 'constants/api';

export const useGetCampaignAnalyticsExport = () => {
  return useQuery({
    queryKey: ['campaigns', 'analytics', 'export'],
    enabled: false,
    queryFn: async () => {
      const { data } = await api.get('/campaign/analytics/export ', {
        responseType: 'blob',
      });
      const anchor = document.createElement('a');
      const href = URL.createObjectURL(data);
      anchor.href = href;
      anchor.download = `Campaign Analytics Export  ${dayjs(Date.now()).format(
        'YYYY-MM-DD HH:mm'
      )}.csv`;
      // some browser needs the anchor to be in the doc
      document.body.append(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(href);

      return null;
    },
  });
};
